<div
    class="tw-grid tw-gap-4 tw-grid-cols-[10px_1fr] tw-mt-[46px] md:tw-grid-cols-[100px_10px_1fr_1.5fr_180px] md:tw-w-[100%] md:tw-mx-auto"
    *ngFor="let event of events; let i = index"
    [id]="event?.id"
>
    <div
        class="tw-flex tw-items-center tw-gap-2 tw-col-span-2 md:tw-col-span-1 md:tw-row-start-2 md:tw-row-end-5 md:tw-items-start"
    >
        <div
            class="tw-w-[10px] tw-h-[10px] tw-bg-[#084CB3] tw-rounded-xl"
        ></div>
        <div class="tw-text-[22px] tw-font-semibold tw-leading-4">
            {{ event.date }}
        </div>
    </div>
    <div
        class="tw-flex tw-col-span-2 md:tw-col-span-3 md:tw-row-start-1 md:tw-col-start-3"
        *ngIf="event.tophat"
    >
        <div
            class="tw-px-3 tw-py-[4px] tw-rounded tw-bg-[#FF40CA] tw-font-semibold tw-text-[#F1F1F1] tw-text-lg"
        >
            {{ event.tophat }}
        </div>
    </div>
    <div
        class="tw-row-span-3 tw-w-[10px] tw-h-full tw-rounded-lg md:tw-row-span-2 md:tw-row-start-2"
        [ngClass]="event.pastDate ? 'tw-bg-[#D5D4D4]' : event.meta.class"
    ></div>
    <div
        class="tw-text-2xl tw-font-semibold md:tw-col-span-2 md:tw-row-start-2"
    >
        {{ event.title }}
        <button
            *ngIf="!event.isRegisterEventDisable"
            (click)="copyLink(event.id)"
            mat-mini-fab
            class="tw-ml-[5px]"
        >
            <svg
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
                class="tw-inline tw-w-6 tw-h-6 tw-text-[#5F6368] hover:tw-text-[#4B6EEC]"
            >
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961"
                />
            </svg>
        </button>
    </div>
    <div class="md:tw-row-start-3">
        <div class="tw-font-bold tw-text-[#8D8D8D] tw-mb-1">
            {{ "LNDP_CALENDAR.TIME" | translate }}:
        </div>
        <div class="tw-text-lg tw-font-semibold">
            {{ event.startTime }} - {{ event.endTime }}
        </div>
    </div>
    <div class="md:tw-row-start-3">
        <div class="tw-font-bold tw-text-[#8D8D8D] tw-mb-1">
            {{ "LNDP_CALENDAR.VENUE" | translate }}:
        </div>
        <div class="tw-text-lg tw-font-semibold">
            {{ event.venue }}
        </div>
    </div>
    <div
        class="tw-col-span-2 tw-overflow-hidden tw-text-[#8D8D8D] md:tw-row-start-4 md:tw-col-start-3 md:tw-col-span-3"
        #eventDescriptionPara
        [ngClass]="event.descriptionExpand ? 'tw-h-auto' : 'tw-h-[20px]'"
    >
        {{ event?.eventDescription }}
    </div>
    <div
        class="tw-col-span-2 md:tw-col-span-1 md:tw-col-start-5 md:tw-row-start-2"
    >
        <button
            class="tw-rounded-[32px] tw-bg-[#FFE5CC] tw-h-[48px] tw-w-full tw-pl-[21px] tw-pr-[8px] tw-font-semibold tw-flex tw-justify-between tw-items-center"
            (click)="onRegisterEvent(event.isRegistered, event.id, event.title)"
            [disabled]="event.isRegisterEventDisable"
            [ngClass]="
                event.isRegisterEventDisable
                    ? 'tw-bg-gray-200 tw-text-slate-400'
                    : 'tw-bg-[#FFE5CC] tw-text-[#FF8819]'
            "
        >
            <div
                *ngIf="
                    event.isRegistered == 'Not Registered to Event' ||
                    event.isRegistered == 'Not Logged In'
                "
            >
                {{ "LNDP_CALENDAR.REGISTER" | translate }}
            </div>
            <div *ngIf="event.isRegistered == 'Registered to Event'">
                {{ "LNDP_CALENDAR.REGISTERED" | translate }}
            </div>
            <div
                class="tw-w-[32px] tw-h-[32px] tw-rounded-full tw-flex tw-justify-center tw-items-center"
                [ngClass]="
                    event.isRegisterEventDisable
                        ? 'tw-bg-slate-400'
                        : 'tw-bg-[#FF8819]'
                "
            >
                <mat-icon
                    fontIcon="arrow_forward"
                    class="tw-text-[19px] tw-text-white tw-mt-1"
                ></mat-icon>
            </div>
        </button>
    </div>
    <div
        class="tw-col-span-2 tw-flex tw-gap-2 tw-items-center tw-justify-center tw-cursor-pointer md:tw-row-start-5 md:tw-col-start-3 md:tw-col-span-1 md:tw-justify-start"
    >
        <ng-container *ngIf="checkOverflow(eventDescriptionPara)">
            <div class="tw-font-semibold" (click)="toggleDescription(event.id)">
                {{ "LNDP_CALENDAR.SEE_MORE" | translate }}
            </div>
            <mat-icon
                fontIcon="expand_more"
                (click)="toggleDescription(event.id)"
            ></mat-icon>
        </ng-container>

        <ng-container *ngIf="event.descriptionExpand">
            <div class="tw-font-semibold" (click)="toggleDescription(event.id)">
                {{ "LNDP_CALENDAR.SEE_LESS" | translate }}
            </div>
            <mat-icon
                fontIcon="expand_less"
                (click)="toggleDescription(event.id)"
            ></mat-icon>
        </ng-container>
    </div>
</div>
